import React, { useState, useEffect } from 'react';
import ItemCard from './ItemCard';

const Home = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async () => {
    try {
      const response = await fetch('https://backend-alien.vercel.app/api/main/items', {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem('userData')).authtoken}`,
        },
      });
      const data = await response.json();
      setItems(data.items);
    } catch (error) {
      console.error('Error fetching items:', error.message);
    }
  };

  return (
    <div className="container mx-auto">
      <h1 className="text-3xl font-semibold mb-8">Items</h1>
      <div className="grid grid-cols-3 gap-4">
        {items.map((item) => (
          <ItemCard key={item._id} item={item} />
        ))}
      </div>
    </div>
  );
};

export default Home;
